/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useUserCampo } from "../../../hooks/useUserCampos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useVariedades } from "../hooks/useVariedades";

export const OrdenFilters = ({
  values,
  handleChange,
  setFieldValues,
  onDownloadClick,
}) => {
  const { getVariedades } = useVariedades();
  const { getCampos } = useUserCampo();

  const [camposOptions, setCamposOptions] = useState([]);
  const [variedadesOptions, setVariedadesOptions] = useState([]);

  const handleCampoChange = (e) => {
    const id_campo = Number(e.target.value);
    const selected_campo = camposOptions.find(
      (item) => item.idcampo === id_campo
    );
    setFieldValues("campo", id_campo);
    if (selected_campo) {
      setFieldValues("campo_name", selected_campo.campo);
    } else {
      setFieldValues("campo_name", "");
    }
  };

  useEffect(() => {
    const getVariedadesOptions = async () => {
      const response = await getVariedades();
      setVariedadesOptions(response);
    };
    const getCamposByUser = async () => {
      const response = await getCampos();
      setCamposOptions(response);
    };
    getCamposByUser();
    getVariedadesOptions();
  }, []);

  return (
    <div className="row">
      <div className="col-md-3 col-sm-12">
        <label>Fecha</label>
        <input
          className="form-control"
          type="date"
          value={values.fecha}
          onChange={handleChange}
          name="fecha"
        />
      </div>
      <div className="col-md-3 col-sm-12">
        <label>Campo</label>
        <select
          className="form-control"
          onChange={handleCampoChange}
          name="campo"
          value={values.campo}
        >
          <option value={0}>Seleccionar...</option>
          {camposOptions?.map((item) => (
            <option value={item.idcampo} key={item.idcampo}>
              {item.campo}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-3 col-sm-12">
        <label>Variedad</label>
        <select
          className="form-control"
          value={values.variedad}
          onChange={handleChange}
          name="variedad"
        >
          <option value={0}>Seleccionar...</option>
          {variedadesOptions?.map((item) => (
            <option value={item.tipo} key={item.idtipo}>
              {item.tipo}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-2 col-sm-12">
        <button
          className="btn btn-outline-success mt-4"
          onClick={onDownloadClick}
        >
          <FontAwesomeIcon icon="fa-regular fa-file-excel" />
        </button>
      </div>
    </div>
  );
};
